import React, { useState } from "react"
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
} from "reactstrap"
import Logo from "../../images/logo.png"

const Header = () => {
  const [isOpen, setIsOpen] = useState(false)

  const toggle = () => setIsOpen(!isOpen)

  return (
    <Navbar fixed="top" center light expand="sm">
      <div className="container">
        <NavbarBrand href="/">
          <img src={Logo} height="50px" width="auto" alt="Freelancology" />
        </NavbarBrand>
        <NavbarToggler onClick={toggle} />
        <Collapse isOpen={isOpen} navbar>
          <Nav className="ml-auto" navbar tabs>
            <NavItem>
              <NavLink href="/">Home</NavLink>
            </NavItem>
            <NavItem>
              <NavLink href="/technologies">Technology</NavLink>
            </NavItem>
            <NavItem>
              <NavLink href="/education">Education</NavLink>
            </NavItem>
            <NavItem>
              <NavLink href="/international">International</NavLink>
            </NavItem>
            <NavItem>
              <NavLink href="/sports">Sport</NavLink>
            </NavItem>
            <NavItem>
              <NavLink href="/movies-and-showbiz">Movies </NavLink>
            </NavItem>
            <NavItem>
              <NavLink href="/about">About</NavLink>
            </NavItem>
            <NavItem>
              <NavLink href="/contact">Contact</NavLink>
            </NavItem>
          </Nav>
        </Collapse>
      </div>
    </Navbar>
  )
}

export default Header
